import { defineStore } from 'pinia';

export const commonStore = defineStore('commonStore', {
  state: () => ({
    accessType:'agent'
}),

actions: {
    setAccessType(type)
    {
        this.accessType = type;
    },
    
},
persist: true,
});
